import React, { Component } from 'react';
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Table, {
    TableRow,
    TableCell
} from "@amzn/meridian/table";
import {SDDwellingRowMapping} from '../../commons/dataStore/PackageResultsData';
import { processConditionalMetrics } from '../../util/MetricUtils';
import {handlePackageStateMapping} from "../../commons/CommonUtils";
import { FiltersStateContext } from '../../commons/context/FiltersStateContext';
import Link from "@amzn/meridian/link";
import Loader from "@amzn/meridian/loader";
import {getLocalTimeDeliveryWindowFromUtcDeliveryWindow} from "../../util/CommonUtils";

import chevronDownSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-down-small"
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small"
import Icon from "@amzn/meridian/icon"
import {FormattedMessage} from "react-intl";
import RefreshTimer from "../../commons/RefreshTimer";

//We might need to add marked for reprocess here
let HELD_STATUSES = ["Pending Reinduct", "Pending Induct"]

export default class SDDwellingDataUI extends Component {

    static contextType = FiltersStateContext;
    constructor(props) {

        super(props)
        this.state = {
            expandedSections : [],
            view : "SD_DWELLING_VIEW",
            data : props.data
        }

        this.getMetricFromPackageToColumnMap = (section, column, direction) => {
            section = section && section.split(":", 2)[1] ? section.split(":", 2)[1] : section ;
            var sectionData = this.props.data.filter(status => status.packageStatus === section);
            var timeToMetricDataMapForSection = sectionData && sectionData.length > 0 ? sectionData : [];
            var t = direction ?  timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null) ?
                timeToMetricDataMapForSection.find(section => section.metaDataMap ? section.metaDataMap.direction === direction : null).columnToViewDataMap : [] :
                (timeToMetricDataMapForSection.length > 0 ? timeToMetricDataMapForSection[0].columnToViewDataMap : [])
            return t[column] ? t[column].value : 0
        }

        /**
         * This calculates total count for section metric
         */
        this.getSectionMetricFromSubsectionData = (section, column) => {
            var totalCount = 0;
            section.Subsections.length > 0 ?
                section.Subsections.map(subsection =>  subsection.Section ?
                    subsection.Subsections.map(s => totalCount+= Number(this.getMetricFromPackageToColumnMap((s.localeCompare(subsection.Section) !== 0 ? s : ""), column,  ""))) :
                    (totalCount += Number(this.getMetricFromPackageToColumnMap(subsection.localeCompare(section.Section) !== 0 ?
                        subsection.split(" (", 1)[0]: "", column,  subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")))) :
                //In case when there is no subsection
                totalCount += Number(this.getMetricFromPackageToColumnMap(section.Section, column))
            return totalCount

        }

        this.toggleRow = section => {

            if (this.state.expandedSections.indexOf(section) !== -1) {
                this.setState({
                    expandedSections : this.state.expandedSections.filter(expandedSection => expandedSection !== section)}
                )
            }
            else  {
                this.setState({
                    expandedSections : this.state.expandedSections.concat(section)
                })
            }
        }

        this.isSectionExpanded = section => {
            return (this.state.expandedSections.indexOf(section) !== -1);
        }


        this.constructState = (section, deliveryWindow, sectionHeader) => {

            let subsections = Array.isArray(section)  ? [].concat.apply([], section): section;
            var values = {
                packageStatuses : Array.isArray(subsections ) ? subsections  : [subsections],
                deliveryWindow : [deliveryWindow],
                packageTypes  : ["Core Volume"],
                leg : this.context.selectedFilterValues.leg,
                eadSection : HELD_STATUSES.includes(sectionHeader) || HELD_STATUSES.includes(subsections) ? true : false,
                page: "SD_DWELL",
                stationTimeZone: (this.props.stationTimeZone).replaceAll('/','%2f')
            }

            //Redirect to search path
            var path = window.location.href;
            var searchPath = path[path.length - 1] === "/" ? path + "packageSearch/" : path + "/packageSearch/";
            return searchPath + JSON.stringify({...values , ...this.props.appliedFilterURL });

        }

        this.parseDeliveryWindowAndConvertLocal = data => {
            var stationTimeZone = this.props.stationTimeZone;
            let deliveryWindowSet = new Set();
            data.forEach((row) => {
                deliveryWindowSet = new Set([ ...deliveryWindowSet, ...Object.keys(row.columnToViewDataMap)])
            });

            const deliveryWindowMap = [...deliveryWindowSet].map((deliveryWindow) => {
                return {
                    'deliveryWindow' : deliveryWindow,
                    'deliveryWindowLocal' : getLocalTimeDeliveryWindowFromUtcDeliveryWindow(deliveryWindow, stationTimeZone)
                }
            });

            deliveryWindowMap.sort((a,b) => {
                return (parseInt(a.deliveryWindowLocal.split(':')[0], 10) > parseInt(b.deliveryWindowLocal.split(':')[0], 10)) ? 1
                    : (parseInt(b.deliveryWindowLocal.split(':')[0], 10) > parseInt(a.deliveryWindowLocal.split(':')[0], 10)) ? -1 : 0;
            });
            return deliveryWindowMap;

        }
    }

    render() {

        const formattedIdPrefix = "commons.";
        let Columns = [
            {
                'deliveryWindow' : 'No Delivery Window',
                'deliveryWindowLocal' : 'No Delivery Window'
            }
        ];
        if (this.props.data && this.props.data.length > 0) {
            Columns = this.parseDeliveryWindowAndConvertLocal(this.props.data)
        }
        const sdDwellingRowMapping = processConditionalMetrics(this.props.data, SDDwellingRowMapping);

        return (
            <div>
                <Row widths={["grid-10"]} wrap="down" spacingInset="large none">
                    <RefreshTimer deps={[this.props.data]}/>
                    <div style={{ overflowX: "auto", width: "100%" }}>
                        <Table spacingInset="medium" spacing="medium"
                               headerRows={1}
                               headerColumns={1}
                               fixHeaderRows = {true}
                               fixHeaderRowsFullWidth={true}
                               stickyHeaderColumn={true} >
                        <TableRow >
                            <TableCell alignmentHorizontal = "left">

                                <Text type="h100">
                                    <FormattedMessage id="sdDwell.status" defaultMessage="Status"/>
                                </Text>
                            </TableCell>
                            {Columns.map(col =>
                                <TableCell alignmentHorizontal = "right"><Text type="h100">{col.deliveryWindowLocal}</Text></TableCell>)}
                        </TableRow>
                        { this.props.isLoading ? <TableRow><TableCell columnSpan = {7} alignmentHorizontal = "center"><Loader/></TableCell></TableRow>:
                            this.props.data && this.props.data.length > 0 && sdDwellingRowMapping.map(section => (

                                <TableRow highlightOnHover={true} key={section.Section} open={this.isSectionExpanded(section.Section)} onClick={() => this.toggleRow(section.Section)}>
                                    <TableCell  alignmentHorizontal = "left"><FormattedMessage id ={formattedIdPrefix.concat(section.Section.split(' ').join('_').toLocaleLowerCase())} defaultMessage={section.Section}/></TableCell>
                                    { Columns.map( col =>
                                        <TableCell alignmentHorizontal = "right">
                                            {this.getSectionMetricFromSubsectionData(section, col.deliveryWindow).toString() !== "0" ?

                                                <Link href =  {this.constructState( section.Subsections.length > 0 ?  section.Subsections.map( subsection => {return subsection.Section ? subsection.Subsections.filter(sub=> sub !== subsection.Section.split(":", 1)[0]).map(s => s.split(":", 1)[0]) :
                                                    subsection}) : section.Section, col.deliveryWindow, section.Section)} type="secondary">
                                                    {" "}

                                                    {this.getSectionMetricFromSubsectionData(section, col.deliveryWindow)}
                                                </Link> : this.getSectionMetricFromSubsectionData(section, col.deliveryWindow)}
                                        </TableCell> )}

                                    { section.Subsections.map(subsection => subsection.Section ? subsection.Subsections.map(sub => sub === subsection.Section ?
                                        <TableRow highlightOnHover={true} key={subsection.Section} open={this.isSectionExpanded(subsection.Section)} onClick={() => this.toggleRow(subsection.Section)}>
                                            <TableCell alignmentHorizontal = "left">
                                                <Row spacingInset="none none none medium">
                                                    <Icon tokens={this.isSectionExpanded(subsection.Section) ? chevronDownSmallTokens : chevronRightSmallTokens}/>
                                                    <FormattedMessage id ={formattedIdPrefix.concat(subsection.Section.toLocaleLowerCase().split(' ').join('_'))} defaultMessage={subsection.Section}/></Row>
                                            </TableCell>
                                            { Columns.map( col => <TableCell alignmentHorizontal = "right">
                                                {this.getSectionMetricFromSubsectionData(subsection , col.deliveryWindow).toString() !== "0" ?
                                                    <Link href = {this.constructState(subsection.Subsections.length > 0 ? subsection.Subsections.filter( s => s.split(":", 1)[0] !== subsection.Section).map(s => s.split(":", 1)[0]) :
                                                        subsection.Section, col.deliveryWindow, subsection.Section)} type="secondary">
                                                        {this.getSectionMetricFromSubsectionData(subsection, col.deliveryWindow)}
                                                    </Link> : this.getSectionMetricFromSubsectionData(subsection, col.deliveryWindow)}
                                            </TableCell> )} </TableRow> :
                                        this.isSectionExpanded(subsection.Section) ? <TableRow>
                                                <TableCell  alignmentHorizontal = "left"><Row spacingInset="none none none xlarge"><FormattedMessage id ={formattedIdPrefix.concat(sub.split(":", 1)[0].split(" (")[0].toLocaleLowerCase().split(' ').join('_'))} defaultMessage={sub.split(":", 1)[0].split(" (")[0]}/></Row></TableCell>
                                                { Columns.map( col =>   <TableCell alignmentHorizontal = "right">
                                                    {this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.deliveryWindow, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ?
                                                        <Link href = {this.constructState(sub.split(":", 2)[1] ? sub.split(":", 2)[0] : sub, col.deliveryWindow, subsection.Section)} type="secondary">
                                                            {this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.deliveryWindow, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                                        </Link> : this.getMetricFromPackageToColumnMap(sub.split(":", 2)[1] ? sub.split(":", 2)[1] : sub.split(" (")[0], col.deliveryWindow, sub.split(" (", 2)[1] ? sub.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                                </TableCell> )} </TableRow>

                                            : null ):

                                        <TableRow highlightOnHover={true}>
                                            <TableCell alignmentHorizontal = "left"><Row spacingInset="none none none medium"><FormattedMessage id ={formattedIdPrefix.concat(handlePackageStateMapping("SD_DWELL", section.Section, subsection).toLocaleLowerCase().split(' ').join('_'))} defaultMessage={subsection}/></Row></TableCell>
                                            { Columns.map(col =>

                                                <TableCell alignmentHorizontal = "right">
                                                    {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.deliveryWindow, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "").toString() !== "0" ?
                                                        <Link href = {this.constructState(subsection, col.deliveryWindow)} type="secondary">

                                                            {this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.deliveryWindow, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}

                                                        </Link> : this.getMetricFromPackageToColumnMap(subsection.split(" (", 1)[0], col.deliveryWindow, subsection.split(" (", 2)[1] ? subsection.split(" (", 2)[1].split(")" , 1)[0] : "")}
                                                </TableCell>)}
                                        </TableRow> )
                                    }
                                </TableRow>
                            ))}
                    </Table>
                    </div>
                </Row>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/sdDwelling/SDDwellingDataUI.js